export enum ErrorType {
  ValidationError = "ValidationError",
  BusinessError = "BusinessError",
  AuthorizationError = "AuthorizationError",
  NotFoundError = "NotFoundError",
  DuplicateError = "DuplicateError"
}
